module.exports = __webpack_public_path__ + "49156b40471457f3621f480fb683ec5f.jpg";